<template>
  <v-container fluid style="height: 100%; padding-bottom: 125px">
    <v-row>
      <v-col sm="4" lg="3" cols="12" style="padding-bottom: 20px; max-height: 60px">
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          single-line
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col sm="4" md="3" lg="2" cols="12" style="padding-bottom: 20px">
        <v-btn
          style="width: 100%; margin: 0"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="assignTemplate()"
        >AGREGAR VEHICULO</v-btn>
      </v-col>
      <v-col sm="4" md="3" lg="2" cols="12" style="padding-bottom: 20px">
        <v-btn
          style="width: 100%; margin: 0"
          large
          v-if="saveChangesOn"
          :color="colorTheme"
          class="white--text"
          v-on:click="saveChanges()"
        >Aplicar</v-btn>
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <v-data-table
          v-model="selectedT2"
          :headers="headersVehAT"
          :items="vehiclesAT"
          item-key="Id"
          :loading="loadingTableInTemplatesAT"
          :loading-text="$t('loadingTextForTable')"
          :show-select="false"
          class="elevation-1"
          :items-per-page="5"
          :search="search"
          :no-data-text="$t('noResults')"
          :footer-props="{
          'items-per-page-text': $t('rows'),
          'items-per-page-all-text': $t('all')
        }"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row justify="start">
                <v-col
                  lg="1"
                  md="1"
                  sm="1"
                  cols="12"
                  class="pr-0"
                >{{ $t("address").toUpperCase() }}:</v-col>
                <v-btn
                  class="pl-0"
                  text
                  small
                  :color="colorTheme"
                  v-on:click="openMap(item)"
                >{{ address }}</v-btn>
              </v-row>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }}
            {{ $t("of").toLowerCase() }} {{ items.itemsLength }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="assignTemplate1" max-width="620">
      <v-card>
        <v-card-title class="headline">Seleccione los vehiculos para asignar en la plantilla1</v-card-title>
        <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
        <v-row style="padding: 10px;">
          <v-col sm="12" md="6" lg="6" cols="12" style="padding-bottom: 20px; max-height: 60px">
            <v-text-field
              solo
              :label="$t('search')"
              append-icon="mdi-magnify"
              single-line
              v-model="searchAssign"
              :color="colorTheme"
            ></v-text-field>
          </v-col>
          <v-col lg="12" md="12" sm="12">
            <v-data-table
              v-model="selectedT"
              :headers="headersAddVehicle"
              :items="vehiclesAT"
              item-key="MovilId"
              :loading="loadingTableInTemplatesAT"
              :loading-text="$t('loadingTextForTable')"
              show-select
              class="elevation-1"
              :items-per-page="5"
              :search="search"
              :no-data-text="$t('noResults')"
              :footer-props="{
          'items-per-page-text': $t('rows'),
          'items-per-page-all-text': $t('all')
        }"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row justify="start">
                    <v-col
                      lg="1"
                      md="1"
                      sm="1"
                      cols="12"
                      class="pr-0"
                    >{{ $t("address").toUpperCase() }}:</v-col>
                    <v-btn
                      class="pl-0"
                      text
                      small
                      :color="colorTheme"
                      v-on:click="openMap(item)"
                    >{{ address }}</v-btn>
                  </v-row>
                </td>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="mdi-alert"
              >{{ $t("noResults") }} : "{{ search }}".</v-alert>
              <template v-slot:footer.page-text="items">
                {{ items.pageStart }} - {{ items.pageStop }}
                {{ $t("of").toLowerCase() }} {{ items.itemsLength }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn :color="colorTheme" text @click="closeDialog()">{{ $t("cancel").toUpperCase() }}</v-btn>

          <v-btn
            :disabled="selectedT.length == 0"
            :color="colorTheme"
            text
            @click="sendSaveData()"
          >{{ $t("accept").toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :absolute="true" v-model="finish">
      <v-card width="300" :light="overlayCard">
        <v-card-text v-if="!showMessage" style="padding-top: 20px; text-align: -webkit-center;">
          {{ $t("await") }}
          <v-progress-circular
            class="mb-0"
            :size="70"
            :width="4"
            indeterminate
            :color="colorTheme"
            style="display: flex;"
          ></v-progress-circular>
        </v-card-text>

        <v-card-text v-else style="padding-top: 20px; text-align: -webkit-center;">
          {{ $t("confirmation") }}
          <v-progress-circular
            class="mb-0"
            :size="70"
            :width="4"
            :value="100"
            :color="colorTheme"
            style="display: flex;"
          >
            <v-icon size="50" :color="colorTheme">mdi-check</v-icon>
          </v-progress-circular>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions v-if="showMessage">
          <v-btn :color="colorTheme" text v-on:click="back()">
            {{
            $t("accept").toUpperCase()
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "assignTemplate",
  data: () => ({
    search: "",
    searchAssign: "",
    selectedT: [],
    selectedT2: [],
    dialogConfirm: false,
    assignTemplate1: false,
    saveChangesOn: false
  }),
  created() {
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("configTemplates").toUpperCase(),
      this.$t("templateAssignment").toUpperCase(),
      "",
      "",
      true
    ]);

    this.cancel();
  },
  mounted() {
    this.$store.dispatch("catalogTemplatesAT");
    this.$store.commit("backgroundCard");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "templatesAT",
      "loadingTableInTemplatesAT",
      "showTemplates",
      "vehiclesAT",
      "optionsGroup",
      "overlayCard",
      "finish",
      "valueDeterminate"
    ]),
    showMessage: {
      get: function() {
        return this.$store.state.showMessage;
      },
      set: function() {
        this.$store.commit("showMessage", [false, false]);
      }
    },
    headersVehAT() {
      return [
        // {
        //   text: i18n.t("group").toUpperCase(),
        //   value: "Group",
        //   align: "center",
        //   filter: this.groupFilter
        // },
        {
          text: i18n.t("vehicle").toUpperCase(),
          value: "MovilId",
          align: "center"
        },
        {
          text: i18n.t("nick").toUpperCase(),
          value: "Nick",
          align: "center"
        },
        {
          text: i18n.t("config").toUpperCase(),
          value: "Template",
          align: "center"
        },
        {
          text: i18n.t("lastConfig").toUpperCase(),
          value: "LastConfiguration",
          align: "center"
        },
        {
          text: i18n.t("statusT").toUpperCase(),
          value: "Status",
          align: "center"
        },
        {
          text: i18n.t("lastTransmission").toUpperCase(),
          value: "LastTransmission",
          align: "center"
        },
        {
          text: i18n.t("idleTime").toUpperCase(),
          value: "IdleTime",
          align: "center"
        }
      ];
    },
    headersAddVehicle() {
      return [
        // {
        //   text: i18n.t("group").toUpperCase(),
        //   value: "Group",
        //   align: "center",
        //   filter: this.groupFilter
        // },
        {
          text: i18n.t("vehicle").toUpperCase(),
          value: "MovilId",
          align: "center"
        },
        {
          text: i18n.t("nick").toUpperCase(),
          value: "Nick",
          align: "center"
        },
        {
          text: i18n.t("config").toUpperCase(),
          value: "Template",
          align: "center"
        },  
        {
          text: i18n.t("lastConfig").toUpperCase(),
          value: "LastConfiguration",
          align: "center"
        }
      ];
    }
  },
  methods: {
    assignTemplate() {
      this.assignTemplate1 = true;
    },
    sendSaveData() {
      this.assignTemplate1 = false;
      this.saveChangesOn = true;
    },
    closeDialog() {
      this.assignTemplate1 = false;
    },
    saveChanges() {
      this.$store.commit("showMessage", [true, false]);
      setTimeout(() => this.$store.commit("showMessage", [true, true]), 2000);
    },
    cancel() {
      this.$store.commit("showMessage", [false, false]);
    },
    back() {
      this.$store.commit("showMessage", [false, false]);
      this.$router.replace({ name: "settingsAT" });
    },
    close() {
      this.$store.commit("errorMessage", false);
    }
  }
};
</script>
